


























































































































































import { Watch, Vue, Prop } from "vue-property-decorator";
import Component from "vue-class-component";
import DateTimePicker from "@/components/DatetimePicker.vue";
import Passenger from "../models/Passenger";
import vuetifyToast from "vuetify-toast";
import { RolePermission } from "@/models/Role";
import PassengerDestination from "@/components/Passenger/models/PassengerDestination";
import Routes from "../../../Routes";
import Trip from "../../../components/Passenger/models/Trip";

@Component({
  components: {
    DateTimePicker
  }
})
export class PassengerTripList extends Vue {
  
  tripsStartDate: string = new Date().toISOString().substr(0, 10);
  tripsEndDate: string = new Date().toISOString().substr(0, 10);

  selectAllTripsStatus: boolean = false;
  tripsHaveBeenSearched: boolean = false;

  showCancelDialog: boolean = false;
  cancelreason: string = '';
  cancelreasonrules: any[] = [val => this.cancelReasonRequired(val)];
  cancelreasonvalid = false;

  @Prop({ default: null }) private passenger: Passenger;

  get userCanReadPassengers(): boolean {
    return this.$store.getters['auth/hasPassengerPermission']([RolePermission.ReadPassengers]);
  }

  get destinationId(): number {
    if (this.passenger && this.passenger.destinationIds.length > 0) {
      return this.passenger.destinationIds.find(d => d);
    }
    return 0;
  }

  get tripHeaders(): any[] {
    return [
      {
        text: this.$i18n.translate(
          "passenger.prop.trips.startPlace",
          "Start place"
        ),
        align: "left",
        sortable: false,
        value: "startPlace"
      },
      {
        text: this.$i18n.translate(
          "passenger.prop.trips.endPlace",
          "End place"
        ),
        align: "left",
        sortable: false,
        value: "endPlace"
      },
      {
        text: this.$i18n.translate(
          "passenger.prop.trips.startTime",
          "Start time"
        ),
        align: "left",
        sortable: false,
        value: "startDateTime"
      },
      {
        text: this.$i18n.translate("passenger.prop.trips.endTime", "End time"),
        align: "left",
        sortable: false,
        value: "endDateTime"
      },
      {
        text: this.$i18n.translate(
          "passenger.prop.trips.cancelledAt",
          "Cancelled at"
        ),
        align: "left",
        sortable: false,
        value: "cancelledAt"
      }
    ];
  }

  get disableSearchTrips() {
    if (this.loadingTrips) {
      return true;
    }
    if (!this.passenger.movitId) {
      return true;
    }
    if (!this.userCanReadPassengers) {
      return true;
    }
    if (this.passenger.inactive) {
      return true;
    }
    if (!this.destinationId) {
      return true;
    }
    return false;
  }

  get disableCancelTrips() {
    if (this.disableSearchTrips) {
      return true;
    }
    if (this.selectedTripsCount === 0) {
      return true;
    }
    return false;
  }

  get loadingTrips(): boolean {
    return this.$store.state.passenger.pending.getPassengerTrips;
  }

  get sortedTrips(): Trip[] {
    const tripArray = this.$store.state.passenger.trips;

    tripArray.sort((a, b) => {
      const dateA = new Date(a.startDateTime ? a.startDateTime : a.endDateTime);
      const dateB = new Date(b.startDateTime ? b.startDateTime : b.endDateTime);

      return dateA <= dateB;
    });

    return tripArray;
  }

  get selectedTripsCount() {
    const selection = this.$store.state.passenger.trips.filter(
      t => t.selectedForCancelling
    );
    return selection.length;
  }

  startDateUpdated(value) {
    this.tripsStartDate = value;
    if (value > this.tripsEndDate) {
      this.tripsEndDate = value;
    }
    const maxEnd = new Date(value);
    maxEnd.setMonth(maxEnd.getMonth() + 1);
    if (new Date(this.tripsEndDate).getTime() > maxEnd.getTime()) {
      this.tripsEndDate = maxEnd.toISOString().substr(0, 10);
    }
  }

  endDateUpdated(value) {
    this.tripsEndDate = value;
    if (value < this.tripsStartDate) {
      this.tripsStartDate = value;
    }
    const minStart = new Date(value);
    minStart.setMonth(minStart.getMonth() - 1);
    if (new Date(this.tripsStartDate).getTime() < minStart.getTime()) {
      this.tripsStartDate = minStart.toISOString().substr(0, 10);
    }
  }

  onSearchTripsClick() {
    this.getPassengerTrips();
  }

  async getPassengerTrips() {
    if (!this.passenger.movitId || !this.destinationId) {
      return;
    }

    await this.$store.dispatch("passenger/getPassengerTrips", {
      params: {
        passengerId: this.passenger.id,
        startDate: this.tripsStartDate,
        endDate: this.tripsEndDate,
        destinationId: !!this.destinationId ? this.destinationId : 0,
      }
    });
    this.tripsHaveBeenSearched = true;
    this.clearSelections();
  }

  forceSelectionForTrips(value) {
    this.sortedTrips.forEach(t => {
      if (!t.cancelledAt) {
        t.selectedForCancelling = value;
      }
    });
  }

  clearSelections() {
    this.selectAllTripsStatus = false;
    this.sortedTrips.forEach(t => (t.selectedForCancelling = false));
  }

  toggleItemPicked(trip: Trip, value) {
    trip.selectedForCancelling = value;
    const theTrip = this.sortedTrips.find(t => t.id === trip.id);
  }

  toggleAllPicked() {
    if (this.selectAllTripsStatus === true) {
      this.forceSelectionForTrips(false);
      this.selectAllTripsStatus = false;
    } else {
      this.forceSelectionForTrips(true);
      this.selectAllTripsStatus = true;
    }
  }

  cancelReasonRequired(val: string) {
    return !!val || Vue.i18n.translate('validation.rules.required', 'Required');
  }

  async onCancelTripsClick() {
    const toBeCancelled = this.sortedTrips.filter(
      t => t.selectedForCancelling === true
    );
    const cancellation = {
      reason: this.cancelreason,
      trips: toBeCancelled
    };
    await this.$store
      .dispatch("passenger/cancelTrips", {
        params: {
          passengerId: this.passenger.id
        },
        data: cancellation
      })
      .then(result =>
        this.getPassengerTrips()
          .finally
          // this.getPassengerTrips()
          ()
      );

    this.showCancelDialog = false;
  }

  mounted() {
    this.tripsHaveBeenSearched = false;
  }
}

export default PassengerTripList;
